import { apiSlice } from "app/api/apiSlice"


export const healthSettingsApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['healthSettings', 'healthDataCount'],
    endpoints: builder => ({
        getHealthSettings: builder.query({
            query: () => 'health/settings',
            keepUnusedDataFor: 5,
            providesTags: ['healthSettings']
        }),
        setHealthSettings: builder.mutation({
            query: data => ({
                url: 'health/settings',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['healthSettings']
        }),
        countHealthData: builder.query({
            query: () => ({
                url: 'health/data/info',
                method: 'GET'
            }),
             keepUnusedDataFor: 5,
            providesTags: ['healthDataCount']
        }),
        deleteHealthData: builder.mutation({
            query: () => ({
                url: 'health/data',
                method: 'DELETE'
            }),
            invalidatesTags: ['healthDataCount']
        }),
    })
})

export const {
    useGetHealthSettingsQuery,
    useLazyGetHealthSettingsQuery,
    useSetHealthSettingsMutation,
    useCountHealthDataQuery,
    useDeleteHealthDataMutation
} = healthSettingsApiSlice